// @flow
import * as React from 'react';
import classNames from 'classnames';

import styles from './HighlightTable.module.scss';;


type Props = {
  children: React.Node,
  className?: string,
}

export const Table = ({ children, className }: Props) => (
  <table className={classNames(styles.table, className)}>
    <tbody>
      {children}
    </tbody>
  </table>
);

export const Row = ({ children, className }: Props) => (
  <tr className={classNames(styles.tr, className)}>
    {children}
  </tr>
);

type LineProps = {
  className?: string,
}

export const RowLine = ({ className }: LineProps) => (
  <React.Fragment>
    <tr className={classNames(styles.lineTop, className)}>
      <td />
      <td />
    </tr>
    <tr className={styles.lineBottom}>
      <td />
      <td />
    </tr>
  </React.Fragment>
);

export const Cell = ({ children, className }: Props) => (
  <td className={classNames(styles.td, className)}>
    {children}
  </td>
);

export const CellWide = ({ children, className }: Props) => (
  <td className={classNames(styles.tdWide, className)} colSpan={2}>
    {children}
  </td>
);
